import React, { useEffect, useState, forwardRef } from "react";
import { Trans } from "react-i18next";
import "../styles/components/SelectOption.scss";
import ValidationError from "./ValidationError";

const SelectOption = (props: any) => {
  const [selected, setSelected] = useState(props.defaultSelected);

  const handleOnChange = (e: any) => {
    setSelected(e.target.value);
    props.onChange(e);
  };

  useEffect(() => {
    setSelected(props?.defaultSelected);
  }, [props?.defaultSelected]);

  return (
    <>
      <div className="selectOption">
        <label className="label-1">
          {props?.label_key ? (
            <>
              <Trans i18nKey={props?.label_key}></Trans>{" "}
              {props?.mandate && <span className="mandetory">*</span>}
            </>
          ) : (
            props.label
          )}
        </label>
        <select
          value={selected || "DEFAULT"}
          onChange={handleOnChange}
          id={props?.id}
          data-testid="selectOption"
          disabled={props?.disabled === undefined ? false : !props.disabled}
          className={props?.className && props?.className}
        >
          {!props?.defaultSelected && (
            <option value="DEFAULT" disabled className="optionStyles">
              {props.adminSearchInfo || <Trans i18nKey={"list.select"}></Trans>}
            </option>
          )}
          {props?.options?.map((option: any, index: number) => {
            return (
              <option key={`select-option-${index}`} value={props.value}>
                <Trans i18nKey={option?.label}></Trans>
              </option>
            );
          })}
        </select>
      </div>
      <ValidationError error_key={props?.error} />
    </>
  );
};

export default SelectOption;
